import { render, staticRenderFns } from "./MemDetail.vue?vue&type=template&id=5a25ced2&scoped=true"
import script from "./MemDetail.vue?vue&type=script&lang=js"
export * from "./MemDetail.vue?vue&type=script&lang=js"
import style0 from "./MemDetail.vue?vue&type=style&index=0&id=5a25ced2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a25ced2",
  null
  
)

export default component.exports